export enum ActionType {
  GET_SHIPOUT_WAITING_REQUEST = `shipments/shipout-waiting/GET_SHIPOUT_WAITING_REQUEST`,
  GET_SHIPOUT_WAITING_REQUEST_SUCCESS = `shipments/shipout-waiting/GET_SHIPOUT_WAITING_REQUEST_SUCCESS`,
  GET_SHIPOUT_WAITING_REQUEST_FAILURE = `shipments/shipout-waiting/GET_SHIPOUT_WAITING_REQUEST_FAILURE`,

  CLEAR_MESSAGE_ERROR = `shipments/shipout-waiting/CLEAR_MESSAGE_ERROR`,
  CLEAR_STATE = `shipments/shipout-waiting/CLEAR_STATE`,
}

export type Action = any;
//   | FSA<ActionType.TOKEN_REQUEST>
